import template from './videoPlayer.html';
import '../videoPlayer.scss';

/**
 * @ngdoc controller
 * @name VideoPlayer
 * @description
 * This component renders the video player.
 */
class VideoPlayer {
  /**
   * @param {$sce} $sce  To make Strict Contextual Escaping of the video url.
   */
  constructor($sce) {
    'ngInject';

    /**
     * The local reference to the `$sce` service.
     * @type {$sce}
     */
    this.$sce = $sce;
  }
  /**
   * Each time the mediaVideoUrl binding changes, update the videoUrl variable
   * depending if the source is youtube or not.
   *
   * @param {Object} changes                The binding changes.
   * @param {Object} changes.mediaVideoUrl  The mediaVideoUrl change object.
   */
  $onChanges({ mediaVideoUrl }) {
    if (mediaVideoUrl && mediaVideoUrl.currentValue && this.mediaVideoUrl) {
      if (this.mediaSource === 'youtube') {
        const url = this.mediaVideoUrl.split('/').pop().replace('watch?v=', '');
        this.videoUrl = this.$sce.trustAsResourceUrl(`//www.youtube.com/embed/${url}?autoplay=1`);
      } else {
        this.videoUrl = this.$sce.trustAsResourceUrl(this.mediaVideoUrl);
      }
    }
  }
}

/**
 * @ngdoc component
 * @name videoPlayer
 * @description
 * The video player component.
 */
export default {
  /**
   * The controller class for the component.
   * @type {VideoPlayer}
   */
  controller: VideoPlayer,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings.
   * @type {Object}
   * @property {Boolean} isPreview      If the video player will be used for preview purposes.
   * @property {String}  mediaImage     The media image to display as a poster.
   * @property {String}  mediaSource    The media source to decide to show a video or an iframe tag.
   * @property {String}  mediaVideoUrl  The media video url to reproduce.
   */
  bindings: {
    isPreview: '@',
    mediaImage: '@',
    mediaSource: '@',
    mediaVideoUrl: '@',
  },
};
